var selectStoreReviewOrderMapFromMap = null,
    getDetailsMapFromMap = null,
    closeInfopin = null,
    getDirectionList = null,
    getDetailsMapFromMap = null,
    getDirectionFromMap = null,
    selectfavStoreMap = null,
    removefavStoreMap;
(function() {
    angular.module('cvsApp').directive('storeLocatorSearch', ['cvsAppData', 'getFavoriteStoresService', 'getStoreLocationService',
        'manageFavoriteStoresService', '$q', '$state', 'checkStoreopen', 'webTrendsService', 'retrieveTimeStampService', '$uibModal','getAddressSuggestionService', 
        function(CAD, GFSS, GSLS, MFS, $q, $state, $checkStoreopen, WTS, RTSS, $uibModal,GASS) {
        return {
            restrict: 'E',
            templateUrl: '../storelocator/app/components/storelocator-search/storeLocatorSearch.html',
            controller: ['$scope', '$location', '$rootScope', '$filter', '$window', 'checkFavoriteStore', '$cookies', 'PagerService', 'validation', function($scope, $location, $rootScope, $filter, $window, CFS, $cookies, PagerService, VF) {
                $scope.SLC = this;

                angular.element("#specialtySpinner").show();
                angular.element("#loader").show();
                var map = null;
                var storeLocators;
                $scope.SLC.map = '';
                $scope.SLC.mapKey = 'AkezKYdo-i6Crmr6nW9y0Ce_72T-osA8SwDdbgvfMSrKL47FVwQOpjBRGW_ON5Aq';
                $scope.SLC.selectedStore = {};
                $scope.SLC.mode = cvsUtility.queryMap.mode ? cvsUtility.queryMap.mode : 'Portal';
                $scope.SLC.isMobile = cvsUtility.isMobile();
                $scope.SLC.isIpad = cvsUtility.isIpad();
                $scope.SLC.selectedStore.selectedStore = {};
                $scope.SLC.filterMe = false;
                    $scope.SLC.reviewStore = CAD.getReviewOrder();
                    // if($scope.SLC.reviewStore){
                    //     $scope.SLC.listView = false;
                    //     $scope.SLC.mapView = true;
                    //     $scope.SLC.mapViewsize = true;
                    //     $scope.SLC.listViewsize = false;
                    // } else {
                    //     $scope.SLC.listView = true;
                    //     $scope.SLC.mapView = true;
                    //     $scope.SLC.mapViewsize = false;
                    //     $scope.SLC.listViewsize = true;
                    // }

                $scope.SLC.listView = true;
                $scope.SLC.mapView = true;
                $scope.SLC.mapViewsize = false;
                $scope.SLC.listViewsize = true;
                $scope.SLC.onLoad = true;
                $scope.SLC.filterClicked = false;
                $scope.SLC.showResults = true;
                $scope.SLC.useMyLocation = false;
                $scope.SLC.getStoreStatus = [];
                CAD.setOnLoad($scope.SLC.onLoad);
                $scope.SLC.renderMap = false;
                $scope.SLC.tokenID = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                //$scope.SLC.favStoreslistID = [];
                $scope.SLC.smallestDis = [];
                $scope.SLC.typeaheadStoreList = [];
                $scope.SLC.searchClicked = false;
                $scope.SLC.searchMode = true;
                $scope.SLC.showIndicator = false;
                $scope.SLC.pager = {};
                $scope.SLC.setPage = {}
                $scope.SLC.currentPaginationPage = "";
                $scope.SLC.currentindex = 0;
                $scope.SLC.cookiesStore = $cookies.get('favCookieStore');

                $rootScope.showStoreDetailsView = false;
                $scope.SLC.noStoresFound = false;
                $scope.SLC.stores = [];
                $scope.SLC.onBackMode = false;
                $scope.SLC.storeLocationTypeaHead = false;
                //$scope.typeaheadStoreLocationView = false;
                //var infoboxLayer = new Microsoft.Maps.EntityCollection();
                //var pinLayer = new Microsoft.Maps.EntityCollection();
                var pins = [];
                var infobox = '';
                var positionObj = null;

                if (cvsUtility.isMobile()) {
                    $scope.SLC.carousal = 'myCvs';
                } else {
                    $scope.SLC.carousal = 'others';
                }

                //Fix 1
                // RTSS.retrieveTimeStamp(onServerTimeStampSuccess);

                // function onServerTimeStampSuccess (data) {
                //     if(data.SERVER_ERROR){

                //         var pageError = cvsUtility.getPageError(data, 'NonFatal', 'retrieveTimeStamp');
                //         WTS.webTrendsUtag("LINK",{ page_error: pageError},undefined);
                //         var date=new Date();
                //         // $rootScope.serverTimeStamp=date.toUTCString();
                //     }

                //     if(data.getError() === '') {
                //         $rootScope.serverTimeStamp = data.apiResponse.timeStamp?data.apiResponse.timeStamp:'';

                //     }else{
                //         /**
                //          * sankar 02/10/2016 - SMP 009 - retrieveTimeStamp service error
                //          * Modified page_error tag
                //          */
                //         WTS.webTrendsUtag("LINK",{ page_error: 'NonFatal | retrieveTimeStamp | '+data.getError().statusCode+' | '+data.getError().statusDesc},undefined);
                //     }

                // }


                //$scope.SLC.reviewStore = true;

                var localstoredstore = '';
                if ($window.localStorage['recentlyViewedStore'] !== 'undefined') {
                    localstoredstore = angular.fromJson($window.localStorage['recentlyViewedStore']);
                }
                ////console.log('localstoredstore',localstoredstore);
                $scope.SLC.localstoragestores = {
                    store: localstoredstore
                };
                ////console.log('lllll',$scope.SLC.localstoragestores);


                //if (cvsUtility.getWindowWidth() < 992) {
                if ($scope.SLC.isMobile) {
                    $scope.SLC.listView = true;
                    $scope.SLC.mapView = false;
                    $scope.SLC.isMobile = true;
                }
                // set focus on modal title
                setTimeout(function(){
                    let setFocus = document.getElementById('store-title');
                    if(setFocus){
                     setFocus.focus();
                    }
                },1200)
               
                $scope.SLC.findStore = function(lati, longi) {

                    if ($scope.SLC.storeName || lati || longi) {
                        var storeNumber = (/^\d+$/.test($scope.SLC.storeName) && $scope.SLC.storeName.length <= 4);
                        var storeName = true;
                        if (storeNumber) {
                            storeName = false;
                        }
                        if (lati && longi) {
                            storeNumber = false;
                            storeName = false;
                        }
                        // if($scope.SLC.filterClicked){
                        //     lati = ""
                        //     longi = ""
                        // }
                        var tokenID, tokenType;
                        tokenID = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                        tokenType = CAD.getTokenType() ? CAD.getTokenType() : 'Login';


                        var storeDetails = {
                            apiKey: cvsUtility.queryMap.apikey,
                            address: storeName ? $scope.SLC.storeName : "",
                            storeNumber: storeNumber ? $scope.SLC.storeName : "",
                            iPAddress: "",
                            latitude: lati ? lati : "",
                            longitude: longi ? longi : "",
                            radius: 10,
                            maxResults: 100,
                            tokenID: tokenID,
                            tokenType: tokenType,
                            driveThru: "N",
                            store24HR: "N",
                            carePlus: "N",
                            immunization: $scope.SLC.immunization ? 'Y' : 'N',
                            minuteClinic: $scope.SLC.minuteclinic ? 'Y' : 'N',
                            pharmacy24HR: $scope.SLC.Pharmacy24hr ? 'Y' : 'N'
                            // token: cvsUtility.queryMap.token
                            //timeStamp: cvsUtility.queryMap.timeStamp ? cvsUtility.queryMap.timeStamp : (cvsUtility.queryMap.timestamp ? cvsUtility.queryMap.timestamp : '')
                        };
                        window.localStorage.setItem("immunization", $scope.SLC.immunization);
                        window.localStorage.setItem("minuteclinic", $scope.SLC.minuteclinic);
                        window.localStorage.setItem("Pharmacy24hr", $scope.SLC.Pharmacy24hr);
                        if($scope.SLC.searchMode){
                            
                            angular.element("#specialtySpinner").show();
                            angular.element("#loader").show();
                            GSLS.getStoreLocation(storeDetails, storeSearchSuccess, 'PZN');
                        }
                        else{
                            //$scope.SLC.typeaheadStoreList = [];
                            if($scope.SLC.storeName && $scope.SLC.storeName.length >= 3){
                                GASS.getAddressSuggestionsData($scope.SLC.storeName,
                                            getAddressSuggestion);
                            }
                            //GSLS.getStoreLocation(storeDetails, storeSuccess, 'PZN');
                        }


                    }
                    else{
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                    }

                };
                // $scope.SLC.init = function() {

                //     //if($scope.SLC.mode && ($scope.SLC.mode ==='Portal' || $scope.SLC.mode ==='App'))
                //     if (cvsUtility.queryMap.tokenId && cvsUtility.queryMap.tokenId !== '' && $scope.SLC.mode && $scope.SLC.mode !== '') {
                //         GFSS.getFavoriteStores(favStoreSuccess);
                //         if (!cvsUtility.mobilecheck() && $scope.SLC.cookiesStore && $scope.SLC.cookiesStore.length > 0) {
                //            $scope.SLC.findStore($scope.SLC.cookiesStore[0].favCookieStore.Latitude, $scope.SLC.cookiesStore[0].favCookieStore.Longitude);
                //         } else {
                //             $scope.SLC.getGeolocation();
                //         }
                //     } else if ($scope.SLC.mode && $scope.SLC.mode !== '' && (!cvsUtility.queryMap.tokenId || cvsUtility.queryMap.tokenId === '')) {
                //         if ($scope.SLC.mode == 'Portal') {
                //             if (!cvsUtility.mobilecheck() && $scope.SLC.cookiesStore && $scope.SLC.cookiesStore.length > 0) {
                //                 $scope.SLC.findStore($scope.SLC.cookiesStore[0].favCookieStore.Latitude, $scope.SLC.cookiesStore[0].favCookieStore.Longitude);
                //             } else {
                //                 //console.log('unregistered user');
                //                 $scope.SLC.getGeolocation();
                //             }
                //         } else if ($scope.SLC.mode == 'App') {
                //             $scope.SLC.getGeolocation();
                //         }
                //     } else if ($scope.SLC.reviewStore) {
                //         GFSS.getFavoriteStores(favStoreSuccess);
                //     } else {
                //         $scope.SLC.getGeolocation();
                //     }
                // }

                $scope.SLC.getGeolocation = function() {

                    if (cvsUtility.queryMap.mobileAppStyle) {
                        if ($scope.SLC.onLoad && cvsUtility.queryMap.latitude && cvsUtility.queryMap.latitude != '' && cvsUtility.queryMap.longitude && cvsUtility.queryMap.longitude != '') {
                            $scope.SLC.findStore(cvsUtility.queryMap.latitude, cvsUtility.queryMap.longitude);
                        } else if (native && cvsUtility.isAndroid()) {
                            if(native.hasOwnProperty('getCurrentLocation')){
                            var position = native.getCurrentLocation();
                            position = JSON.parse(position);
                            showCurrentPositionStores(position);
                            }
                            else if (cvsUtility.queryMap.latitude && cvsUtility.queryMap.latitude != '' && cvsUtility.queryMap.longitude && cvsUtility.queryMap.longitude != '') {
                                $scope.SLC.findStore(cvsUtility.queryMap.latitude, cvsUtility.queryMap.longitude);
                            }
                            else{
                                $scope.SLC.map = new Microsoft.Maps.Map(document.getElementById('myMapL'), {
                                    credentials: $scope.SLC.mapKey,
                                    mapTypeId: "r",
                                    zoom: 0
                                });
                                drawDefaultNorthAmericaMap();
                                setTimeout(function(){
                                    angular.element("#specialtySpinner").hide();
                                    angular.element("#loader").hide();
                                }, 500);
                            }
                        } else if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(showCurrentPositionStores, function(error) {
                                $scope.SLC.map = new Microsoft.Maps.Map(document.getElementById('myMapL'), {
                                    credentials: $scope.SLC.mapKey,
                                    mapTypeId: "r",
                                    zoom: 0
                                });
                                drawDefaultNorthAmericaMap();
                                setTimeout(function(){
                                    angular.element("#specialtySpinner").hide();
                                    angular.element("#loader").hide();
                                }, 500);
                            });
                        }
                    } else if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(showCurrentPositionStores, function(error) {

                            $scope.SLC.map = new Microsoft.Maps.Map(document.getElementById('myMapL'), {
                                credentials: $scope.SLC.mapKey,
                                mapTypeId: "r",
                                zoom: 0
                            });
                            drawDefaultNorthAmericaMap();
                            setTimeout(function(){
                                angular.element("#specialtySpinner").hide();
                                angular.element("#loader").hide();
                            }, 500);
                        });
                    }
                    else {
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                        drawDefaultNorthAmericaMap();
                    }
                };

                $scope.SLC.init = function() {
                    /**
                     * IM5916145 - SP 06/19/2017
                     * Handling loading indicator.
                     */
                 
                    //     setTimeout(function(){
                    //         angular.element("#specialtySpinner").show();
                    //         angular.element("#loader").show();
                    //         }, 500);
              
                 

                    if ($rootScope.detailsBackClicked && !$scope.SLC.reviewStore) {
                        $scope.SLC.onBackMode = true;
                        $scope.SLC.useMyLocation = true;
                        $scope.SLC.searchClicked = true;
                        $scope.SLC.onLoad = false;
                        $scope.SLC.carousal = 'others';
                        $scope.SLC.latitude = 'lat';
                        $scope.SLC.longitude = 'long';
                        //$scope.SLC.listView = false;
                        //$scope.SLC.mapView = true;
                        var view = window.localStorage.getItem("viewSelected");
                        $scope.SLC.storeName = (window.localStorage.getItem("storeName") && window.localStorage.getItem("storeName") != 'undefined') ? window.localStorage.getItem("storeName") : ''  ;
                        $scope.SLC.storeNameList = $scope.SLC.storeName;
                        $scope.SLC.storeNameRes = $scope.SLC.storeName;
                        $scope.SLC.carousal = 'others';
                        $scope.SLC.FavStores = [];
                        $scope.SLC.stores = [];
                        $scope.SLC.stores = JSON.parse(window.localStorage.getItem("stores"));
                        $scope.SLC.totalStores = JSON.parse(window.localStorage.getItem("stores"));
                        if (!$scope.SLC.isMobile) {
                            setPagination($scope.SLC.stores);
                        }
                        storeLocators = $scope.SLC.stores;
                        $scope.SLC.immunization = (window.localStorage.getItem("immunization") === "true") ? true : false
                        $scope.SLC.minuteclinic = (window.localStorage.getItem("minuteclinic") === "true") ? true : false
                        $scope.SLC.Pharmacy24hr = (window.localStorage.getItem("Pharmacy24hr") === "true") ? true : false
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                        //positionObj = JSON.parse(window.localStorage.getItem("position"));
                        //drawMap("myMapL", "");
                        setTimeout(function() {
                            drawMap("myMapL", "");
                        }, 2000);
                        return;
                        //$scope.SLC.findStore();
                    }

                    if($scope.SLC.reviewStore){
                        $scope.SLC.useMyLocation = true;
                        $scope.SLC.searchClicked = true;
                        $scope.SLC.onLoad = false;
                        $scope.SLC.getGeolocation();
                    }
                    else if ($scope.SLC.tokenID) {
                        GFSS.getFavoriteStores(favStoreSuccess);

                    } else {
                        var tokenId = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                        if ($scope.SLC.mode && $scope.SLC.mode !== '' && (!tokenId || tokenId === '')) {
                            if ($scope.SLC.mode === 'Portal') {
                                if (!cvsUtility.mobilecheck() && $scope.SLC.cookiesStore && $scope.SLC.cookiesStore.length > 0) {
                                    $scope.SLC.findStore($scope.SLC.cookiesStore[0].favCookieStore.Latitude, $scope.SLC.cookiesStore[0].favCookieStore.Longitude);
                                } else {
                                    $scope.SLC.getGeolocation();
                                }
                            } else {
                                $scope.SLC.getGeolocation();
                            }
                        }
                    }
                    if(cvsUtility.mobilecheck() && !$scope.SLC.reviewStore){
                        $scope.SLC.getGeolocation();
                    }

                };
                $rootScope.checkOpen = function(item, pharOrStore) {
                    var openStatus = checkStoreCloseOpen(item,pharOrStore);
                    return openStatus;

                };

                $rootScope.checkOpenReview = function(item,pharOrStore){
                    var openStatus = checkStoreCloseOpen(item,pharOrStore);
                    if(openStatus){
                        return "<span class='openHrs'>Open&nbsp;</span>";
                    }else{
                        return "<span class='closeHrs'>Closed&nbsp;</span>";
                    }
                }

                var openTel = function(number) {
                    if (cvsUtility.setNativeCheck()) {
                        native.openExtUrl('tel:' + number);
                    } else {
                        $window.open('tel:' + number)
                    }
                }


                $scope.SLC.currentLocation = function() {
                    $scope.SLC.onLoad = false;
                    CAD.setOnLoad($scope.SLC.onLoad);
                    $scope.SLC.carousal = 'others';
                    $scope.SLC.searchClicked = true;
                    $scope.SLC.searchMode = true;
                    $scope.SLC.latitude = 'lat';
                    $scope.SLC.longitude = 'long';
                    $scope.SLC.FavStores = [];
                    $scope.SLC.filterClicked = false;
                    angular.element("#specialtySpinner").show();
                    angular.element("#loader").show();
                    $scope.SLC.storeName = "";
                    $scope.SLC.useMyLocation = true;
                    $scope.SLC.getGeolocation();
                };



                function showCurrentPositionStores(position) {
                    if(position && position.coords && position.coords.latitude && position.coords.longitude){
                    $scope.SLC.findStore(position.coords.latitude, position.coords.longitude);
                }
                    else{
                        setTimeout(function(){
                            angular.element("#specialtySpinner").hide();
                            angular.element("#loader").hide();
                        }, 500);
                    }
                }

                function drawDefaultNorthAmericaMap() {
                    storeLocators = [{
                        latitude: 48.1667,
                        longitude: -100.1667
                    }];
                    drawMap("myMapL", "BLANK");
                }

                function favStoreSuccess(data) {
                    $scope.SLC.searchMode = false;
                    if (data && data.getFavoriteStores() && data.getError() === '') {
                        var favStores = data.getFavoriteStores();

                        if (favStores.length > 0) {
                            var storeFoundCount = 0;
                            var favStoreslist = [];
                            for (var stores in favStores) {
                                if (favStores.hasOwnProperty(stores)) {
                                    favStoreslist.push(favStores[stores].storeDetails.entry);
                                    var infavitem = false;
                                    if (favStores[stores].storeDetails || (favStores[stores].storeDetails)) {
                                        $scope.SLC.favouriteStoreId = favStores[stores].storeDetails.entry.content.properties.EntityID.__text;
                                        //$scope.SLC.favStoreslistID.push(favStores[stores].storeDetails.entry.content.properties.EntityID.__text);

                                        /*var array = $cookies.get('favCookieStore');
                                         if(array.length > 0){
                                         for(var i=0; i<array.length; i++){
                                         if(array[i].favCookieStore.storeNumber === favStores[stores].storeDetails.entry.content.properties.EntityID.__text){
                                         infavitem = true;
                                         }
                                         }
                                         }
                                         if(!infavitem){
                                         array.push({
                                         'favCookieStore': {
                                         storeNumber: favStores[stores].storeDetails.entry.content.properties.EntityID.__text,
                                         Latitude: favStores[stores].storeDetails.entry.content.properties.Latitude.__text,
                                         Longitude: favStores[stores].storeDetails.entry.content.properties.Longitude.__text
                                         }
                                         });
                                         }

                                         $cookies.put('favCookieStore', array);
                                         $scope.SLC.cookiesStore = $cookies.get('favCookieStore');*/

                                        $scope.SLC.selectedStore.selectedStore = favStores[stores].storeDetails.entry;


                                    }
                                }

                            }
                            CAD.setFavStores(favStoreslist);
                            $scope.SLC.FavStores = favStoreslist;
                            $scope.SLC.getStoreStatus = $scope.SLC.FavStores;
                            storesTimings();
                            angular.forEach($scope.SLC.FavStores, function(member, index) {
                                member.currentindex = index;
                            });

                            //storeLocators = [$scope.SLC.stores];
                            storeLocators = favStoreslist;
                            setTimeout(function() {
                                // drawMap("myMapL", "BLANK")
                                drawMap("myMapL", "");
                                // drawDefaultNorthAmericaMap();
                            }, 2000);

                        }
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                        $rootScope.detailsBackClicked = false;
                    } else {
                        // var tokenId = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                        // if (tokenId && tokenId !== '' && $scope.SLC.mode && $scope.SLC.mode === 'Portal') {
                        //     if (!cvsUtility.mobilecheck() && $scope.SLC.cookiesStore && $scope.SLC.cookiesStore.length > 0) {
                        //         $scope.SLC.findStore($scope.SLC.cookiesStore[0].favCookieStore.Latitude, $scope.SLC.cookiesStore[0].favCookieStore.Longitude);
                        //     } else {
                        //         $scope.SLC.getGeolocation();
                        //     }
                        // }
                        if ($scope.SLC.mode && $scope.SLC.mode === 'Portal' || $scope.SLC.reviewStore) {
                            $scope.SLC.searchMode = true;
                            $scope.SLC.getGeolocation();
                        }

                        //drawDefaultNorthAmericaMap();
                    }
                    // var tokenId = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                    // if (tokenId && tokenId !== '' && $scope.SLC.mode && $scope.SLC.mode === 'App') {
                    //     $scope.SLC.getGeolocation();
                    // }
                }

                /*function showCurrentPositionStores(position){
                 $scope.SLC.latitude=position.coords.latitude;
                 $scope.SLC.longitude=position.coords.longitude;
                 }*/
                function loadMap() {
                    var defer = $q.defer();
                    /**
                     * IM5919112 - SP 06/19/2017
                     * Clearing map location container before loading new instance.
                     * @type {string}
                     */
                    document.getElementById('myMapL').innerHTML = "";
                    if (typeof (map) != 'undefined' && map != null) {
                         map.dispose();
                         map = null;
                    }

                    map = new Microsoft.Maps.Map(document.getElementById('myMapL'), {
                        credentials: $scope.SLC.mapKey,
                        mapTypeId: "r",
                        zoom: 4
                    });
                    if (map) {
                        defer.resolve(map);
                    } else {
                        defer.reject()
                    }
                    return defer.promise;
                }

                function drawMap(mapName, type) {
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();
                    // if ($scope.SLC.reviewStore && !$scope.SLC.renderMap) {
                    //     $scope.SLC.renderMap = true;
                    //     return false;
                    // }

                    var storesList = [];
                    $scope.SLC.pinArray = [];
                    if (typeof storeLocators != 'undefined')
                        storesList = storeLocators;

                    if (storesList.length == 0) {

                    }
                    $scope.SLC.count = 0;
                    if (storesList.length > 0) {
                        if (typeof storeLocators != 'undefined' && typeof storeLocators.content != 'undefined')
                            $scope.SLC.noStoreError = false;

                        var locationObj = function(name, latitude, longitude) {
                            this.Name = name;
                            this.Latitude = latitude;
                            this.Longitude = longitude;
                        };

                        var locations = new Array();
                        var locArr = [];
                        //Add the entity pushpins to the map



                        /*loadMap();

                         function loadMap(){
                         if(typeof Microsoft !== undefined && typeof Microsoft.Maps !== undefined
                         && Microsoft.Maps.Map !== null){
                         //Map API available add your map load code.

                         angular.element(document).ready(function () {
                         map = new Microsoft.Maps.Map(document.getElementById('myMapL'), {
                         credentials: $scope.SLC.mapKey,
                         mapTypeId: "r",
                         zoom: 4
                         });
                         });
                         } else {

                         setTimeout(loadMap,100);
                         }
                         }*/

                        /* loadMap().then(function(){
                         //console.log('success');
                         },function(){
                         //console.log('failure');
                         });


                         */
                        if (document.getElementById('myMapL')) {
                            loadMap().then(function(map) {
                                if (type == "BLANK") {


                                    if (storesList && storesList[0].content) {
                                        Microsoft.Maps.registerModule("CustomInfoboxModule", "./../storelocator/app/vendor/V7CustomInfobox.min.js");
                                        Microsoft.Maps.loadModule("CustomInfoboxModule", {
                                            callback: function() {
                                                //Create an instance of the custom infobox control and set intial options
                                                infobox = new CustomInfobox(map, {
                                                    title: 'Map Center',
                                                    color: '#fff',
                                                    showCloseButton: false
                                                });
                                            }
                                        });
                                        Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function() {
                                            var latitude, longitude;
                                            pins = [];
                                            for (var i = 0; i < storesList.length; i++) {
                                                latitude = cvsUtility.removeLineBreak(storesList[i].content.properties.Latitude.__text);

                                                longitude = cvsUtility.removeLineBreak(storesList[i].content.properties.Longitude.__text);

                                                var pin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(latitude, longitude), {
                                                    icon: '../common/images/marker.png',
                                                    text: (storesList[i].currentindex + 1).toString()
                                                });
                                                pins.push(pin);
                                            }

                                            $scope.SLC.createInfoBox(pin, pins, storesList);
                                            var clusterLayer = new Microsoft.Maps.ClusterLayer(pins, {
                                                clusteredPinCallback: function(cluster) {
                                                    cluster.metadata = {
                                                        title: 'Cluster',
                                                        description: 'This is a cluster of ' + cluster.containedPushpins.length + ' pushpins.'
                                                    };
                                                },
                                                gridSize: 80
                                            });

                                            map.layers.insert(clusterLayer);


                                            map.setView({
                                                center: new Microsoft.Maps.Location(storesList[0].content.properties.Latitude.__text.replace(/[\n\t\r]+/g,''), storesList[0].content.properties.Longitude.__text.replace(/[\n\t\r]+/g,'')),
                                                zoom: 12
                                            });

                                        });
                                    } else {

                                        map.setView({
                                            center: new Microsoft.Maps.Location(storesList[0].latitude, storesList[0].longitude),
                                            zoom: 12
                                        });
                                    }
                                } else {
                                    var latitude, longitude;
                                    var pins = [];
                                    Microsoft.Maps.registerModule("CustomInfoboxModule", "./../storelocator/app/vendor/V7CustomInfobox.min.js");
                                    Microsoft.Maps.loadModule("CustomInfoboxModule", {
                                        callback: function() {
                                            //Create an instance of the custom infobox control and set intial options
                                            infobox = new CustomInfobox(map, {
                                                title: 'Map Center',
                                                color: '#fff',
                                                showCloseButton: false
                                            });
                                        }
                                    });
                                    // Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function() {
                                    if (storesList.length) {

                                        for (var i = 0; i < storesList.length; i++) {
                                            //console.log('mmm',storesList[i])
                                            ////console.log('store id ===',storesList[i].content.properties.EntityID.__text);
                                            latitude = cvsUtility.removeLineBreak(storesList[i].content.properties.Latitude.__text);
                                            longitude = cvsUtility.removeLineBreak(storesList[i].content.properties.Longitude.__text);
                                            var pin;
                                            (function(i) {
                                                pin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(latitude, longitude), {
                                                    icon: '../common/images/marker.png',
                                                    text: (storesList[i].currentindex + 1).toString()
                                                });
                                                map.entities.push(pin);
                                                pins.push(pin);
                                            })(i);

                                            Microsoft.Maps.Events.addHandler(pin, 'click', function(args) {
                                                map.setView({
                                                    center: args.target.getLocation(),
                                                    zoom: 12
                                                });
                                                if ($scope.SLC.mapViewsize || $scope.SLC.isMobile) {
                                                    if($scope.SLC.isMobile){
                                                        // infobox.setOptions({ offset: { x: -155, y: 255} });
                                                        infobox.setOptions({

                                                            visible: false

                                                        });
                                                        infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
                                                            visible: false
                                                        });
                                                        infobox.setMap(map);
                                                        infobox.setOptions({
                                                            location: args.target.getLocation(),
                                                            description: args.target.metadata.text,
                                                            visible: true,
                                                            maxHeight: 220,
                                                            maxWidth: 310,
                                                            width: 300

                                                        });
                                                    }
                                                    else{
                                                        $("#myMapL").css('margin-bottom', "150px");
                                                        setTimeout(function(){
                                                            infobox.show(args.target.getLocation(), args.target.metadata.text);
                                                        }, 100);
                                                        /*infobox.setOptions({

                                                         visible: false

                                                         });
                                                         infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
                                                         visible: false
                                                         });
                                                         infobox.setMap(map);
                                                         infobox.setOptions({
                                                         location: args.target.getLocation(),
                                                         description: args.target.metadata.text,
                                                         visible: true,
                                                         maxHeight: 520,
                                                         maxWidth: 710,
                                                         width: 700,
                                                         offset: new Microsoft.Maps.Point(-33, 20)

                                                         });*/

                                                    }


                                                } else {
                                                    infobox.setOptions({
                                                        location: args.target.getLocation(),
                                                        htmlContent: args.primitive.metadata.text,
                                                        visible: false,
                                                    });
                                                }
                                            });
                                        }
                                        $scope.SLC.createInfoBox(pin, pins, storesList);
                                        /*Microsoft.Maps.Events.addHandler(pin, 'click', function() {
                                         infobox.setOptions({
                                         visible: true
                                         });
                                         });*/
                                        /*var clusterLayer = new Microsoft.Maps.ClusterLayer(pins, {
                                         clusteredPinCallback: function(cluster) {
                                         cluster.metadata = {
                                         title: 'Cluster',
                                         description: 'This is a cluster of ' + cluster.containedPushpins.length + ' pushpins.'
                                         };
                                         Microsoft.Maps.Events.addHandler(cluster, 'click', $scope.SLC.pushpinClicked);
                                         },
                                         gridSize: 80
                                         });*/
                                        //$scope.SLC.map.layers.insert(clusterLayer);
                                        // map.layers.insert(clusterLayer);
                                        // map.entities = pins;
                                        //$scope.SLC.map.setView({center:new Microsoft.Maps.Location(storesList[0].content.properties.Latitude.__text, storesList[0].content.properties.Longitude.__text),zoom:12});
                                        setTimeout(function() {
                                            map.setView({
                                                center: new Microsoft.Maps.Location(storesList[0].content.properties.Latitude.__text.replace(/[\n\t\r]+/g,''), storesList[0].content.properties.Longitude.__text.replace(/[\n\t\r]+/g,'')),
                                                zoom: 12
                                            });
                                        }, 100);
                                    }
                                    // });
                                }
                            });
                        }
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                    } else {
                        $scope.SLC.noStoreError = true;
                    }
                };
                var showbox = [];
                var selectStoreReviewOrderMap = function(index) {
                    $scope.SLC.selectedStore = getDirectionList[index];
                    var item = $scope.SLC.selectedStore
                    $scope.SLC.selectAddress = true;
                    var validateAddressResult = VF.validateStorePickUpAddress(getDirectionList[index]);
                    if (validateAddressResult !== "") {
                        $scope.parentScope.selectedStore.selectStore = true;
                        $scope.parentScope.ERROR = {
                            "SERVER_ERROR": true,
                            "ERROR_MSG": validateAddressResult
                        };

                        $scope.parentScope.selectedStore.selectedStore = $scope.SLC.selectedStore;
                        $scope.parentScope.pickOrDel = "pickup";
                        if ($scope.parentScope.selectedStore.selectStore) {
                            $scope.parentScope.pickOrDel = "delivery";
                            $scope.parentScope.selectedStore.selectStore = true;
                        }
                        //deliveryDetailsScope.closePopUP();
                        $scope.closePopUP()
                    } else {
                        item = JSON.parse(JSON.stringify(item));
                        parent.postMessage(item, "*"); 
                        //if(deliveryDetailsScope){
                        $scope.parentScope.selectedStore.selectedStore = $scope.SLC.selectedStore;
                        $scope.parentScope.selectStore = false;
                        $scope.parentScope.pickOrDel = "pickup";
                        $scope.closePopUP();
                        //deliveryDetailsScope.closePopUP();
                        //}
                    }
                }

                $scope.SLC.showMap = function(item) {
                    if (cvsUtility.isMobile()) {
                        if (item == 'list') {
                            $scope.SLC.listView = true;
                            $scope.SLC.mapView = false;
                            window.localStorage.setItem("viewSelected", 'list');
                        } else {
                            $scope.SLC.mapView = true;
                            $scope.SLC.listView = false;
                            window.localStorage.setItem("viewSelected", 'map');
                        }
                    } else {
                        if (item == 'list') {
                            $scope.SLC.mapViewsize = false;
                            $scope.SLC.listViewsize = true;
                            $scope.SLC.listView = true;
                            closeInfopin();
                        } else {
                            $scope.SLC.mapViewsize = true;
                            $scope.SLC.listViewsize = false;
                            $scope.SLC.listView = false;
                        }
                    }
                };
                var getDirection = function(index) {

                    $state.go('store-direction', {
                        storeNumber: getDirectionList[index].content.properties.EntityID.__text
                    });



                };



                var storeId;
                $scope.SLC.checkinFav = function(storenumber) {
                    if (!$scope.SLC.tokenID && $scope.SL.favCookieStore) {
                        var cookesItems = $cookies.get('favCookieStore');
                        if (cookesItems.length > 0) {
                            for (var i = 0; i < cookesItems.length; i++) {
                                if (cookesItems[i].favCookieStore.storeNumber === storenumber) {
                                    return true;
                                }
                            }
                        }
                    } else if ($scope.SLC.tokenID) {
                        var favStores = CAD.getFavStores();
                        if (favStores.length > 0) {
                            for (var i = 0; i < favStores.length; i++) {
                                if (favStores[i] && favStores[i].content && favStores[i].content.properties.EntityID.__text === storenumber) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                }

                $scope.SLC.selectStore = function(item, index) {
                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();
                    storeId = item.content.properties.EntityID.__text;
                    itemToBeAdded = item;
                    var lati = item.content.properties.Latitude.__text.replace(/[\n\t\r]+/g,'');
                    var longi = item.content.properties.Longitude.__text.replace(/[\n\t\r]+/g,'');
                    var array = [];
                    $scope.SLC.selectedIndex = index;
                    var utagObj = {};
                    utagObj.page_name = "Search results";
                    utagObj.store_id = storeId;
                    utagObj.link_name = 'Custom: User Set My CVS';
                    WTS.webTrendsUtag("LINK", utagObj);
                    if ($scope.SLC.tokenID) {
                        MFS.addFavoriteStore(addressAdded, '', 'addStore', storeId);
                    } else {
                        array = [];
                        array.push({
                            'favCookieStore': {
                                storeNumber: storeId,
                                Latitude: lati,
                                Longitude: longi
                            }
                        });
                        $cookies.put('favCookieStore', array);
                        $scope.SL.favCookieStore = $cookies.get('favCookieStore');
                    }

                }

                $scope.SLC.deleteStore = function(item, index) { // added to sl
                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();
                    $scope.SLC.selectedIndex = index;
                    storeId = item.content.properties.EntityID.__text;
                    if ($scope.SLC.tokenID) {
                        MFS.addFavoriteStore(addressDeleted, '', 'deleteStore', storeId);
                    } else {
                        $cookies.put('favCookieStore', []);
                    }

                }

                function addressDeleted(response) {
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                    if(response && (response.SERVER_ERROR || response.getError() !== '')){
                        var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                        WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                        if(response.getError() !== '' && response.getError().hasOwnProperty('statusDesc')){
                            alert(response.getError().statusDesc);
                        }
                        return;
                    }
                    var favStores = CAD.getFavStores();

                    if (favStores.length > 0) {
                        for (var i = 0; i < favStores.length; i++) {
                            if (favStores[i].content.properties.EntityID.__text === storeId) {
                                favStores.splice(i, 1);
                            }
                        }
                    }
                    CAD.setFavStores(favStores)
                    $scope.SLC.FavStores = favStores;
                    if(!$scope.SLC.searchClicked){
                        drawMap("myMapL", "");
                    }
                    document.getElementById('cvsstore').innerHTML = '<img src="../storelocator/app/images/empty-star.png" onclick="selectfavStoreMap(' + $scope.SLC.selectedIndex + ')" /><a onclick="selectfavStoreMap(' + $scope.SLC.selectedIndex + ')"> Add to myCVS &reg;</a>';
                    closeInfopin();
                }

                function addressAdded(response) {
                        angular.element("#specialtySpinner").hide();
                        angular.element("#loader").hide();
                    if(response && (response.SERVER_ERROR || response.getError() !== '')){
                        var pageError = cvsUtility.getPageError(response, 'Fatal', 'manageFavoriteStores');
                        WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                        if(response.getError() !== '' && response.getError().hasOwnProperty('statusDesc')){
                            alert(response.getError().statusDesc);
                        }
                        return;
                    }
                    CAD.pushFavStore(itemToBeAdded);
                    document.getElementById('cvsstore').innerHTML = '<img src="../storelocator/app/images/red-star.png" onclick="removefavStoreMap(' + $scope.SLC.selectedIndex + ')" /><a onclick="removefavStoreMap(' + $scope.SLC.selectedIndex + ')">myCVS&reg; Store</a>';
                }

                $rootScope.closeInfopinOnClose = function() {
                     if(cvsUtility.isMobile()){
                         if(infobox.hasOwnProperty('setOptions')){
                          infobox.setOptions({
                              visible: false
                          });
                         }
                     }
                     else{
                         if(infobox.hasOwnProperty('hide')) {
                             infobox.hide();
                         }
                          $("#myMapL").css('margin-bottom', "0px");
                     }
                }

                //$scope.SLC.storeSelect = function() {}
                $scope.SLC.createInfoBox = function(pin, pins, storesList) {
                    getDirectionList = angular.copy(storesList);
                    var center = pin.getLocation();
                    var pushpin;
                    showbox = [];

                    for (var i = 0; i < pins.length; i++) {

                        pushpin = pins[i];

                        // infobox = new Microsoft.Maps.Infobox(center, {
                        //     title: 'Map Center',
                        //     description: 'Seattle',
                        //     visible: false,
                        //     offset: new Microsoft.Maps.Point(0, 25)
                        // });

                        // infobox.setMap(map);
                        closeInfopin = function() {
                            if(cvsUtility.isMobile()){
                                infobox.setOptions({
                                    visible: false
                                });
                            }
                            else{
                                infobox.hide();
                                $("#myMapL").css('margin-bottom', "0px");
                            }

                        }

                        getDirectionFromMap = function(i) {
                            closeInfopin();
                            var stringifiedStore = JSON.stringify(storesList[i]);
                            if (cvsUtility.setNativeCheck()) {
                                native.locateStoreInMap(stringifiedStore);
                            }
                            else if(cvsUtility.isMobile()) {
                                var store = storesList[i];
                                var popupWindow = window.open('http://maps.apple.com/?q=' + store.content.properties.AddressLine.__text + ',' + store.content.properties.Locality.__text + ',' + store.content.properties.AdminDistrict.__text + ',' + store.content.properties.PostalCode.__text);
                                setTimeout(function () {
                                    popupWindow.close();
                                }, 5000);
                            }
                            else{
                                getDirection(i);
                            }

                        };
                        getDetailsMapFromMap = function(i) {
                            closeInfopin();
                            getDetailsMap(storesList[i]);
                        }
                        selectStoreReviewOrderMapFromMap = function(i) {
                            closeInfopin();
                            selectStoreReviewOrderMap(i);
                        }

                        selectfavStoreMap = function(index) {
                            //console.log("storesList", storesList);
                            $scope.SLC.selectStore(getDirectionList[index], index)
                        };
                        removefavStoreMap = function(index) {
                            //$cookies.remove('favCookieStore');
                            $scope.SLC.deleteStore(getDirectionList[index], index)
                        };

                        var distanceInMiles = $filter('limitTo')(storesList[i].content.properties && storesList[i].content.properties.__Distance && storesList[i].content.properties.__Distance.__text, 4)
                        distanceInMiles = distanceInMiles ? ' (' + distanceInMiles + ' miles' + ')' : '';
                        var addressBlockClass = 'address-block';
                        /*if(cvsUtility.isMobile()){
                         addressBlockClass = '';
                         }*/

                        var infoTemplateReview = '<div  class="store-review-order-popup"><div id="InfoboxCustom"><div style="pointer-events: all;" class="mapInfoBox"><div class="filter-row store-item"><div class="filter-row '+addressBlockClass+'"><div class="filter-row"><div class="filter-column map-details map-details-review"><div class="filter-row"><div class="filter-column filter-column-30 mobile-address ng-binding"><strong class="ng-binding">' + storesList[i].content.properties.AddressLine.__text.split(' ').map(function(wrd) {
                                return wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase();
                            }).join(' ') + '</strong>                            <br>                                 ' + storesList[i].content.properties.Locality.__text.split(' ').map(function(wrd) {
                                return wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase();
                            }).join(' ') + ', ' + storesList[i].content.properties.AdminDistrict.__text + ' ' + storesList[i].content.properties.PostalCode.__text + '<br><span class="ng-binding">' + $rootScope.checkOpenReview(storesList[i], '') + '</span> <strong class="ng-binding">' + distanceInMiles + '</strong>    ';
                        if (storesList[i].content.properties.InStore_Pickup_Flag.__text == 'Y') {
                            infoTemplateReview += '<br/><div class="inside-store"><img src="../storelocator/app/images/inside-store.png" /><span>Inside Target Store</span></div>';
                        }
                        infoTemplateReview +='                    </div><div class="store-select-right-arrow"><a href="javascript:void(0)" onclick="getDetailsMapFromMap(' + i + ');"><img src="../storelocator/app/images/right-arrow.png" alt=">"></a></div><div class="filter-column filter-column-30 select-address">                            <button class="filter_button" onclick="selectStoreReviewOrderMapFromMap(' + i + ')">Select</button>                       </div>                    </div>                </div></div></div></div></div></div></div></div>';

                        //var 'text'+i;

                        //var infoTemplate = 'infoTemplate'+'-'+i;
                        ////console.log('--------------',infoTemplate);
                        //var infoTemplate = '';
                        //infoTemplate = 'asdfasdfasdfasdfaf--'+i;
                        var infoTemplate = '<div id="InfoboxCustom"><div style="pointer-events: all;" class="mapInfoBox"><div class="filter-row store-item"><div class="filter-row '+addressBlockClass+'">';
                        if(!cvsUtility.isMobile()) {
                            infoTemplate += '<div class="filter-row"><a class="sm-close-button" href="javascript:void(0)" onclick="closeInfopin()" title="Close">X</a></div>';
                        }
                        infoTemplate +='<div class="filter-row"><div class="filter-column filter-column-100 map-details"><div class="filter-row"><div class="filter-column filter-column-40 mobile-address"><strong>' + storesList[i].content.properties.AddressLine.__text.split(' ').map(function(wrd) {
                                return wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase();
                            }).join(' ') + '</strong><br>                                ' + storesList[i].content.properties.Locality.__text.split(' ').map(function(wrd) {
                                return wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase();
                            }).join(' ') + ', ' + storesList[i].content.properties.AdminDistrict.__text + '<br>                                ' + storesList[i].content.properties.PostalCode.__text + '<br><span>' + $rootScope.checkOpenReview(storesList[i], '') + '</span><strong>' + distanceInMiles + '</strong></div><div class="store-select-right-arrow"><a href="javascript:void(0)" onclick="getDetailsMapFromMap(' + i + ')"><img src="../storelocator/app/images/right-arrow.png" alt=">"></a></div><div class="filter-column filter-column-60 pharmacy_hrs"><strong class="margin-bottom-10">Store & Photo Hrs:</strong><div class="filter-row"><div class="filter-column-40"><strong>Mon - Fri</strong></div><div  class="filter-column-60 pharmacy-hrs-time">' + $scope.SLC.getDefaultStoreTiming(1, storesList[i]) + '</div></div><div class="filter-row"><div class="filter-column-40"><strong>Sat</strong></div><div class="filter-column-60 pharmacy-hrs-time">' + $scope.SLC.getDefaultStoreTiming(6, storesList[i]) + '</div></div><div class="filter-row"><div class="filter-column-40"><strong>Sun</strong></div><div class="filter-column-60 pharmacy-hrs-time">' + $scope.SLC.getDefaultStoreTiming(7, storesList[i]) + '</div></div></div></div><div class="filter-row store_hrsandservices"><div class="filter-column filter-column-40 filter-column-mob-100 store-id">';
                        if (!$scope.SLC.reviewStore) {
                            infoTemplate += '<strong>Store # ' + storesList[i].content.properties.EntityID.__text + '</strong>';
                        }

                        if (storesList[i].content.properties.InStore_Pickup_Flag.__text == 'Y') {
                            infoTemplate += '<div class="inside-store"><img src="../storelocator/app/images/inside-store.png" /><span>Inside Target Store</span></div>';
                        }
                        infoTemplate += '</div><div class="filter-column filter-column-60 pharmacy_hrs"><strong>Pharmacy Hrs:</strong><div class="filter-row"><div class="filter-column-40"><strong>Mon - Fri</strong></div><div class="filter-column-60">';
                        if (storesList[i].content.properties.Hr24_Flag.__text == 'Y') {
                            infoTemplate += '<span>Open 24 Hours</span>';
                        }
                        if (storesList[i].content.properties.Hr24_Flag.__text == 'N') {
                            var storetime = $scope.SLC.getDefaultStoreHrs(1, storesList[i]);
                            infoTemplate += '<span>' + storetime + '</span>';
                        }

                        infoTemplate += '</div></div><div class="filter-row"><div class="filter-column-40"><strong>Sat</strong></div><div class="filter-column-60">';

                        if (storesList[i].content.properties.Hr24_Flag.__text == 'Y') {
                            infoTemplate += '<span>Open 24 Hours</span>';
                        }
                        if (storesList[i].content.properties.Hr24_Flag.__text == 'N') {
                            var storetime = $scope.SLC.getDefaultStoreHrs(6, storesList[i]);
                            infoTemplate += '<span>' + storetime + '</span>';
                        }

                        infoTemplate += '</div></div><div class="filter-row"><div class="filter-column-40"><strong>Sun</strong></div><div class="filter-column-60">';
                        if (storesList[i].content.properties.Hr24_Flag.__text == 'Y') {
                            infoTemplate += '<span>Open 24 Hours</span>';
                        }
                        if (storesList[i].content.properties.Hr24_Flag.__text == 'N') {
                            var storetime = $scope.SLC.getDefaultStoreHrs(7, storesList[i]);
                            infoTemplate += '<span>' + storetime + '</span>';
                        }

                        if(cvsUtility.isMobile()){
                            infoTemplate += '</div></div></div></div><div class="filter-row"><div class="filter-column filter-column-mob-100">';
                            if (!$scope.SLC.checkinFav(storesList[i].content.properties.EntityID.__text) && $scope.SLC.tokenID) {
                                infoTemplate += '<div class="cvsstore" id="cvsstore"><img src="../storelocator/app/images/empty-star.png"/><a onclick="selectfavStoreMap(' + i + ')"> Add to myCVS&reg;</a></div>';
                            }
                            if ($scope.SLC.checkinFav(storesList[i].content.properties.EntityID.__text) && $scope.SLC.tokenID) {
                                infoTemplate += '<div class="cvsstore" id="cvsstore"><img src="../storelocator/app/images/red-star.png"/><a onclick="removefavStoreMap(' + i + ')">myCVS&reg; Store</a></div>';
                            }
                        }

                        infoTemplate += '</div></div></div></div><div class="filter-row desktop-select"><div class="filter-column filter-column-40 filter-column-mob-100">';
                        if (!$scope.SLC.checkinFav(storesList[i].content.properties.EntityID.__text) && $scope.SLC.tokenID) {
                            infoTemplate += '<div class="cvsstore" id="cvsstore"><img src="../storelocator/app/images/empty-star.png"/><a onclick="selectfavStoreMap(' + i + ')"> Add to myCVS&reg;</a></div>';
                        }
                        if ($scope.SLC.checkinFav(storesList[i].content.properties.EntityID.__text) && $scope.SLC.tokenID) {
                            infoTemplate += '<div class="cvsstore" id="cvsstore"><img src="../storelocator/app/images/red-star.png"/><a onclick="removefavStoreMap(' + i + ')">myCVS&reg; Store</a></div>';
                        }
                        infoTemplate += '</div><div class="filter-column filter-column-60 services"><strong>Services:</strong><ul class="filter-service">';
                        if (storesList[i].content.properties.Rx24_Flag && storesList[i].content.properties.Rx24_Flag.__text == 'Y') {
                            infoTemplate += '<li>24 Hour Flu Clinic</li>';
                        }
                        if (storesList[i].content.properties.Photo_Flag && storesList[i].content.properties.Photo_Flag.__text == 'Y') {
                            infoTemplate += '<li>Photo</li>';
                        }
                        if (storesList[i].content.properties.Drive_Thru && storesList[i].content.properties.Drive_Thru.__text == 'Y') {
                            infoTemplate += '<li>Drive Thru</li>';
                        }
                        if (storesList[i].content.properties.Flu_Flag && storesList[i].content.properties.Flu_Flag.__text == 'Y') {
                            infoTemplate += '<li>Immunization</li>';
                        }

                        infoTemplate += '</ul></div></div></div></div></div><div class="filter-row directionandcall"><div class="filter-column filter-column-50 setLink mar-right"><p class="icon-text"> <img src="../storelocator/app/images/marker-dot.png" ><strong onclick="getDirectionFromMap(' + i + ')"> Directions</strong></p></div><div class="filter-column filter-column-50 setLink"><p class="icon-text icon-text-2"><a target="_parent" href="tel:' + storesList[i].content.properties.Rx_Phone_Num.__text + '"><img src="../storelocator/app/images/call.png"><strong>';
                        infoTemplate += $filter('limitRange')(storesList[i].content.properties.Rx_Phone_Num.__text, 0, 3) + '-' + $filter('limitRange')(storesList[i].content.properties.Rx_Phone_Num.__text, 3, 6) + '-' + $filter('limitRange')(storesList[i].content.properties.Rx_Phone_Num.__text, 6, 10);
                        infoTemplate += '</strong></a></p></div></div><div class="filter-row mobile-selectstore">';
                        if ($scope.SLC.favouriteStoreId != storesList[i].content.properties.EntityID.__text) {
                            infoTemplate += '<div class="filter-row"><button class="select-button">Set as myCVS</button></div>';
                        }
                        if ($scope.SLC.favouriteStoreId == storesList[i].content.properties.EntityID.__text) {
                            infoTemplate += '<div class="filter-row"><button class="store-selected-button"><span class="part1">myCVS</span><span class="part2">Store</span></button></div>';
                        }
                        infoTemplate += '</div></div></div></div>';
                        // Microsoft.Maps.Events.addHandler(pushpin, 'click', $scope.SLC.pushpinClicked);

                        if ($scope.SLC.reviewStore) {
                            showbox.push(infoTemplateReview);
                        } else {
                            showbox.push(infoTemplate);
                        }


                        pushpin.metadata = {
                            title: 'Pushpin ' + i,
                            description: 'Discription for pushpin' + i,
                            EntityID: storesList[i].content.properties.EntityID.__text,
                            text: showbox[i]
                        };


                    }
                };

                $scope.SLC.pushpinClicked = function(e) {
                    // //console.log("is it clicked")
                }
                /**
                 * IM5916145 - SP 06/19/2017
                 * Created new function to use while fetching address suggestions to avoid unncessary location calls.
                 */
                $scope.SLC.searchAddressSuggestions = function(){
                    if($scope.SLC.storeName.length >= 3){
                        $rootScope.typeaheadStoreListValue = null;
                        GASS.getAddressSuggestionsData($scope.SLC.storeName,
                            getAddressSuggestion);
                    }
                };
                
                $scope.SLC.searchStore = function() {
                    if($scope.SLC.showIndicator){
                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();
                    }
                    $scope.SLC.filterMe = false;
                    $scope.SLC.latitude = ""
                    $scope.SLC.longitude = ""
                    $scope.SLC.onLoad = false;
                    $scope.SLC.filterClicked = false;
                    CAD.setOnLoad($scope.SLC.onLoad);
                    if ($scope.SLC.storeName && typeof $scope.SLC.storeName === "object") {
                        $scope.SLC.findStore($scope.SLC.storeName.Point.Latitude, $scope.SLC.storeName.Point.Longitude);
                        //$scope.SLC.storeNameList = "";
                        //$scope.SLC.storeNameList = $scope.SLC.storeName.Name;
                    } else if ($scope.SLC.storeName) {
                        var storeNumber = (/^\d+$/.test($scope.SLC.storeName) && $scope.SLC.storeName.length <= 4);
                        //$scope.SLC.storeNameList = $scope.SLC.storeName;
                        if (storeNumber) {
                           // Call getstorelocations service
                            $scope.SLC.findStore();
                        } else {
                            // Call getaddresssuggestions service
                            // $scope.SLC.findStore();
                            GASS.getAddressSuggestionsData($scope.SLC.storeName, getAddressSuggestion);
                        }
                    }
                    else{
                        $scope.SLC.currentLocation();
                    }
                };
                $scope.SLC.getDefaultStoreTiming = function(date, store) { ////////added to SL
                    if (!store.content) {
                        return false;
                    }
                    switch (date) {
                        case 7:
                            return store.content.properties.Rx_Sun_Hours.__text;
                            break;
                        case 1:
                            return store.content.properties.Rx_Mon_Hours.__text;
                            break;
                        case 2:
                            return store.content.properties.Rx_Tues_Hours.__text;
                            break;
                        case 3:
                            return store.content.properties.Rx_Wed_Hours.__text;
                            break;
                        case 4:
                            return store.content.properties.Rx_Thur_Hours.__text;
                            break;
                        case 5:
                            return store.content.properties.Rx_Fri_Hours.__text;
                            break;
                        default:
                            return store.content.properties.Rx_Sat_Hours.__text;
                            break;
                    }
                };
                $scope.SLC.getDefaultStoreHrs = function(date, store) { ////added to SL need to remove later
                    if (!store.content) {
                        return false;
                    }
                    switch (date) {
                        case 7:
                            if (store.content.properties.Fs_Sun_Hours.__text) {
                                return store.content.properties.Fs_Sun_Hours.__text;
                            } else {
                                return 'N/A';
                            }
                            break;
                        case 1:
                            if (store.content.properties.Fs_Mon_Hours.__text) {
                                return store.content.properties.Fs_Mon_Hours.__text;
                            } else {
                                return 'N/A';
                            }

                            break;
                        case 2:
                            if (store.content.properties.Fs_Tues_Hours.__text) {
                                return store.content.properties.Fs_Tues_Hours.__text;
                            } else {
                                return 'N/A';
                            }

                            break;
                        case 3:
                            if (store.content.properties.Fs_Wed_Hours.__text) {
                                return store.content.properties.Fs_Wed_Hours.__text;
                            } else {
                                return 'N/A';
                            }
                            break;
                        case 4:
                            if (store.content.properties.Fs_Thur_Hours.__text) {
                                return store.content.properties.Fs_Thur_Hours.__text;
                            } else {
                                return 'N/A';
                            }
                            break;
                        case 5:
                            if (store.content.properties.Fs_Fri_Hours.__text) {
                                return store.content.properties.Fs_Fri_Hours.__text;
                            } else {
                                return 'N/A';
                            }
                            break;
                        default:
                            if (store.content.properties.Fs_Sat_Hours.__text) {
                                return store.content.properties.Fs_Sat_Hours.__text;
                            } else {
                                return 'N/A';
                            }
                            break;
                    }
                };

                // $scope.SLC.selectStore = function(item) { //added to storelist
                //     var storeId = item.content.properties.EntityID.__text;
                //     CFS.setFavouriteStore(storeId);

                //     MFS.addFavoriteStore(addressAdded, '', 'addStore', storeId);
                // }

                // $scope.SLC.deleteStore = function(item) { // added to sl
                //     var storeId = item.content.properties.EntityID.__text;
                //     MFS.addFavoriteStore(addressDeleted, '', 'deleteStore', storeId);
                // }
                $scope.SLC.getDetails = function(item) {
                    $state.go('store-detail', {
                        store: item
                    });
                }

                var getDetailsMap = function(item) {
                    closeInfopin();
                    if ($scope.SLC.reviewStore) {
                        $rootScope.showStoreDetailsView = true;
                        $rootScope.showStoreDetailsItem = item;
                        $rootScope.$apply();
                    } else {
                        $state.transitionTo('store-detail', {
                            storeNumber: item.content.properties.EntityID.__text,
                            distance: item.content.properties.hasOwnProperty('__Distance')? item.content.properties.__Distance.__text : null
                        });
                    }
                }
                $scope.SLC.filterMeclick = function() {

                    if ($scope.SLC.filterMe) {
                        $scope.SLC.filterMe = false;
                        angular.element("#specialtySpinner").show();
                        angular.element("#loader").show();
                        $scope.SLC.showIndicator= true;
                        $scope.SLC.searchClicked = true;
                        $scope.SLC.searchMode = true;
                        $scope.SLC.searchClicked = true;
                        $scope.SLC.filterClicked = true;
                        $scope.SLC.searchStore();
                    } else {
                        $scope.SLC.filterMe = true;
                    }
                }
                $scope.SLC.setFilters = function(isClose) {
                    $scope.SLC.filterMe = false;
                };

                function setPagination(data) {

                    $scope.SLC.setPage = setPage;
                    $scope.SLC.setPage(1);

                    function setPage(page) {
                        if (page < 1 || page > $scope.SLC.pager.totalPages) {
                            return;
                        }
                        try{
                            //$('body',window.parent.document).scrollTop(0);
                            window.parent.scroll(0,0);
                        }
                        catch(ex){}
                        // get pager object from service
                        $scope.SLC.pager = PagerService.GetPager(data.length, page);

                        // get current page of items
                        $scope.SLC.stores = data.slice($scope.SLC.pager.startIndex, $scope.SLC.pager.endIndex + 1);
                        $scope.SLC.currentPaginationPage = $scope.SLC.stores[0].currentindex + 1;
                        $scope.SLC.endPaginationPage = $scope.SLC.currentPaginationPage + ($scope.SLC.stores.length - 1);
                        $scope.SLC.completeStoreList = $scope.SLC.stores;
                        storeLocators = $scope.SLC.completeStoreList;

                    }
                }


                $scope.$watch('SLC.stores', function(newValue, oldValue) {
                    if (newValue !== oldValue && $scope.SLC.searchClicked) {
                        drawMap("myMapL", "");
                    }
                });

                $scope.$watch('SLC.FavStores', function(newValue, oldValue) {
                    if (newValue !== oldValue && !$scope.SLC.searchClicked && !$scope.SLC.onLoad) {
                        $scope.SLC.FavStores = CAD.getFavStores();
                        drawMap("myMapL", "");
                    }
                });

                //call back for getstorelocations
                function storeSearchSuccess(data) {
                    //console.log("in storeSearchSuccess");
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();
                //    set focus on status when data load
                    setTimeout(function(){
                        let statusMsgId =  document.getElementById('assfoc');
                        if(statusMsgId){
                          statusMsgId.focus();
                        }
                    },0);
                    
                 
                    /**
                     * IM5937525 - SP 07/13/2017
                     * Showing address suggestions when getStorelocations responds with address suggestions
                     */

                    if(!$scope.SLC.onLoad && data.apiResponse && data.apiResponse.hasOwnProperty("ResourceSets") && data.apiResponse.ResourceSets.ResourceSet
                            && data.apiResponse.ResourceSets.ResourceSet.Resources && data.apiResponse.ResourceSets.ResourceSet.Resources.Location){
                        $scope.SLC.typeaheadStoreList = [];
                        $scope.SLC.storeLocationTypeaHead = true;
                        $scope.SLC.searchMode = false;
                        //$scope.SLC.showResults = true;
                        $scope.SLC.showIndicator = false;
                        var destination = data.apiResponse.ResourceSets.ResourceSet.Resources.Location;
                        if(_.isArray(destination) && Object.prototype.toString.call(destination) === '[object Array]'){
                            angular.forEach(destination,function(location) {
                                $scope.SLC.typeaheadStoreList.push(location);
                            })
                            //$scope.SLC.typeaheadStoreList = _.uniqBy($scope.SLC.typeaheadStoreList, "Name")
                        } else {
                            $scope.SLC.typeaheadStoreList.push(destination);
                        }
                        $rootScope.typeaheadStoreListValue =  $scope.SLC.typeaheadStoreList
                        $rootScope.storeName = $scope.SLC.storeName;
                        angular.element("#typeaheadStoreList").click();
                        angular.element("#typeaheadStoreList").focus();
                    }
                    if ($scope.SLC.searchMode && data && data.apiResponse && data.apiResponse.storeDetails && typeof(data.apiResponse.storeDetails) == "object") {
                        $scope.SLC.searchMode = false;
                        $rootScope.typeaheadStoreListValue = null;
                        $scope.SLC.showResults = true;
                        $scope.SLC.showIndicator = false;
                        $scope.SLC.storeLocationTypeaHead = false;
                        $scope.getStores = data.getStores();
                        //console.log("stores: "+data.getStores());

                        $scope.SLC.getStoreStatus.concat($scope.getStores);
                        storesTimings();

                        ////console.log("$scope.SLC.storeName", $scope.SLC.storeName)
                        if ($scope.SLC.storeName && typeof $scope.SLC.storeName === "object") {
                            $scope.SLC.storeNameList = $scope.SLC.storeName.Name;
                            $scope.SLC.storeNameRes = $scope.SLC.storeName.Name;
                            window.localStorage.setItem("storeName", $scope.SLC.storeName.Name)
                        } else {
                            $scope.SLC.storeNameRes = $scope.SLC.storeName;
                            $scope.SLC.storeNameList = $scope.SLC.storeName;
                            window.localStorage.setItem("storeName", $scope.SLC.storeName)
                        }
                        if (cvsUtility.isMobile() && $scope.SLC.onLoad) {
                            $scope.SLC.onLoad = false;
                            var completeStoreList = data.getStores();
                            $scope.SLC.smallestDis = [];
                            $scope.SLC.smallestDis.push(completeStoreList[0]);
                            angular.forEach($scope.SLC.smallestDis, function(member, index) {
                                member.currentindex = index;
                            });
                            $scope.SLC.typeaheadStoreList = [];
                            $rootScope.detailsBackClicked = false;
                        } else if (cvsUtility.isMobile() && !$scope.SLC.onLoad) {
                            $scope.SLC.carousal = 'others';
                            $scope.SLC.FavStores = [];
                            $scope.SLC.stores = data.getStores();
                            $scope.SLC.completeStoreList = data.getStores();
                            angular.forEach($scope.SLC.stores, function(member, index) {
                                member.currentindex = index;
                            });
                            $scope.SLC.typeaheadStoreList = [];
                            window.localStorage.setItem("stores", JSON.stringify(data.getStores()))
                            $rootScope.detailsBackClicked = true;
                            var utagObj = {};
                            utagObj.page_name = "Search results";
                            utagObj.page_category = "Store locator";
                            utagObj.onsite_search_results = $scope.SLC.stores.length;
                            utagObj.onsite_search_term = $scope.SLC.storeName;
                            WTS.webTrendsUtag("OBJ", utagObj);
                        } else {
                            $scope.SLC.carousal = 'others';
                            $scope.SLC.FavStores = [];
                            $scope.SLC.stores = data.getStores();
                            $scope.SLC.totalStores = $scope.SLC.stores;
                            var utagObj = {};
                            utagObj.page_name = "Search results";
                            utagObj.page_category = "Store locator";
                            utagObj.onsite_search_term = $scope.SLC.storeName;
                            utagObj.onsite_search_results = $scope.SLC.stores.length;
                            WTS.webTrendsUtag("OBJ", utagObj);
                            angular.forEach($scope.SLC.stores, function(member, index) {
                                member.currentindex = index;
                            });
                            $scope.SLC.completeStoreList = $scope.SLC.stores;
                            if (!$scope.SLC.isMobile && !$scope.SLC.reviewStore) {
                                setPagination($scope.SLC.stores);
                            }

                            $scope.SLC.smallestDis = [];
                            $scope.SLC.typeaheadStoreList = [];
                            window.localStorage.setItem("stores", JSON.stringify(data.getStores()))
                            $rootScope.detailsBackClicked = true;
                        }
                        if ($scope.SLC.stores && $scope.SLC.stores.length > 0) {
                            storeLocators = $scope.SLC.completeStoreList;
                            drawMap("myMapL", "");
                        } else if ($scope.SLC.smallestDis && $scope.SLC.smallestDis.length > 0) {
                            storeLocators = $scope.SLC.smallestDis
                            drawMap("myMapL", "");
                        }
                    } else {
                        var pageError = cvsUtility.getPageError(data, 'Fatal', 'getStoreLocations');
                        WTS.webTrendsUtag("OBJ",{ page_error: pageError},undefined);
                        if ($scope.SLC.searchMode) {
                            if ($scope.SLC.storeName && typeof $scope.SLC.storeName === "object") {
                                $scope.SLC.storeNameList = $scope.SLC.storeName.Name;
                                $scope.SLC.storeNameRes = $scope.SLC.storeName.Name;
                                window.localStorage.setItem("storeName", $scope.SLC.storeName.Name)
                            } else {
                                $scope.SLC.storeNameRes = $scope.SLC.storeName;
                                $scope.SLC.storeNameList = $scope.SLC.storeName;
                                window.localStorage.setItem("storeName", $scope.SLC.storeName)
                            }
                            $scope.SLC.noStoresFound = true;
                            $scope.SLC.searchMode = false;
                            $scope.SLC.showIndicator = false;
                            $scope.SLC.typeaheadStoreList = [];
                            $scope.SLC.totalStores = [];
                            $scope.SLC.stores = [];
                            $scope.SLC.smallestDis = [];
                            $scope.SLC.FavStores = [];
                            drawDefaultNorthAmericaMap();
                        }
                    }
                }
                function storeSuccess(data) {
                    //console.log("in storesuccess");
                     if (!$scope.SLC.searchMode && data && data.apiResponse && data.apiResponse.ResourceSets && typeof(data.apiResponse.ResourceSets) == "object") {
                        //$scope.typeaheadStoreLocationView = true;
                        //$scope.SLC.storeNameList = $scope.SLC.storeName.Name;
                        //$scope.SLC.storeNameRes = $scope.SLC.storeName.Name;
                        $scope.SLC.typeaheadStoreList = data.apiResponse.ResourceSets.ResourceSet.Resources.Location;
                        $scope.SLC.showIndicator = false;
                        //$scope.SLC.totalStores = [];
                        //$scope.SLC.stores = [];
                        //$scope.SLC.smallestDis = [];
                        //$scope.SLC.FavStores = [];
                    } else {
                        /*if ($scope.SLC.searchMode) {
                            if ($scope.SLC.storeName && typeof $scope.SLC.storeName === "object") {
                                $scope.SLC.storeNameList = $scope.SLC.storeName.Name;
                                $scope.SLC.storeNameRes = $scope.SLC.storeName.Name;
                                window.localStorage.setItem("storeName", $scope.SLC.storeName.Name)
                            } else {
                                $scope.SLC.storeNameRes = $scope.SLC.storeName;
                                $scope.SLC.storeNameList = $scope.SLC.storeName;
                                window.localStorage.setItem("storeName", $scope.SLC.storeName)
                            }
                            $scope.SLC.noStoresFound = true;
                            $scope.SLC.searchMode = false;
                            $scope.SLC.showIndicator = false;
                            $scope.SLC.typeaheadStoreList = [];
                            $scope.SLC.totalStores = [];
                            $scope.SLC.stores = [];
                            $scope.SLC.smallestDis = [];
                            $scope.SLC.FavStores = [];
                            drawDefaultNorthAmericaMap();
                        }*/
                    }
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();
                }
                //call back for getaddress
                function getAddressSuggestion(data) {
                    //console.log("in storesuccess");
                    //if(!$scope.SLC.searchMode && data && data.getError() === ''){
                    if( data && data.getError() === ''){
                        $scope.SLC.typeaheadStoreList = [];
                        $scope.SLC.storeLocationTypeaHead = true;
                        $scope.SLC.searchMode = false;
                        var destination = data.getAddressResponse().ResourceSet.Resources.Location;
                        if(_.isArray(destination) && Object.prototype.toString.call(destination) === '[object Array]'){
                            angular.forEach(destination,function(location) {
                                $scope.SLC.typeaheadStoreList.push(location);
                            })
                            //$scope.SLC.typeaheadStoreList = _.uniqBy($scope.SLC.typeaheadStoreList, "Name")
                        } else {
                            $scope.SLC.typeaheadStoreList.push(destination);
                        }
                        $rootScope.typeaheadStoreListValue =  $scope.SLC.typeaheadStoreList
                        $rootScope.storeName = $scope.SLC.storeName;
                        angular.element("#typeaheadStoreList").click();
                        angular.element("#typeaheadStoreList").focus();
                    }
                    else{
                        var pageError = cvsUtility.getPageError(data, 'NonFatal', 'getAddressSuggestions');
                        WTS.webTrendsUtag("LINK",{ page_error: pageError},undefined);
                        if ($scope.SLC.searchMode) {
                            $scope.SLC.noStoresFound = true;
                            $scope.SLC.searchMode = false;
                            $scope.SLC.showIndicator = false;
                            $scope.SLC.typeaheadStoreList = [];
                            $scope.SLC.totalStores = [];
                            $scope.SLC.stores = [];
                            $scope.SLC.smallestDis = [];
                            $scope.SLC.FavStores = [];
                            drawDefaultNorthAmericaMap();
                        }
                    }
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();
                }
                function storesTimings() {
                    for (var store in $scope.SLC.getStoreStatus) {
                        if ($scope.SLC.getStoreStatus[store].content && $scope.SLC.getStoreStatus[store].content.properties) {
                            $scope.SLC.getStoreStatus[store]["pharmacyTimings"] = groupTimings($scope.SLC.getStoreStatus[store], "PH");
                            /*checkStoreCloseOpen(SLC.stores[store]);*/
                        }
                    }
                }

                function groupTimings(store, pharOrStore) {
                    var pharmacyMap = [];
                    var days = [{
                        name: "Mon",
                        duration: pharOrStore === "PH" ? store.content.properties.Rx_Mon_Hours.__text : store.content.properties.Fs_Mon_Hours.__text
                    },
                        {
                            name: "Tues",
                            duration: pharOrStore === "PH" ? store.content.properties.Rx_Tues_Hours.__text : store.content.properties.Fs_Tues_Hours.__text
                        },
                        {
                            name: "Wed",
                            duration: pharOrStore === "PH" ? store.content.properties.Rx_Wed_Hours.__text : store.content.properties.Fs_Wed_Hours.__text
                        },
                        {
                            name: "Thur",
                            duration: pharOrStore === "PH" ? store.content.properties.Rx_Thur_Hours.__text : store.content.properties.Fs_Thur_Hours.__text
                        },
                        {
                            name: "Fri",
                            duration: pharOrStore === "PH" ? store.content.properties.Rx_Fri_Hours.__text : store.content.properties.Fs_Fri_Hours.__text
                        },
                        {
                            name: "Sat",
                            duration: pharOrStore === "PH" ? store.content.properties.Rx_Sat_Hours.__text : store.content.properties.Fs_Sat_Hours.__text
                        },
                        {
                            name: "Sun",
                            duration: pharOrStore === "PH" ? store.content.properties.Rx_Sun_Hours.__text : store.content.properties.Fs_Sun_Hours.__text
                        }
                    ];
                    var durationString = days[0]["duration"];
                    var prevDay = days[0]["name"];
                    var startDay = prevDay;
                    var weekdayLength = days.length - 2;
                    for (var day = 0; day < weekdayLength; day++) {
                        var currentDuration = days[day]["duration"];
                        var dayString;
                        if (currentDuration != durationString) {
                            if (day === weekdayLength - 1) {
                                dayString = startDay == days[day - 1]["name"] ? startDay : (startDay + "-" + days[day - 1]["name"]);
                                pharmacyMap.push({
                                    'dayString': dayString,
                                    'durationString': durationString
                                });
                                dayString = days[day]["name"];
                                durationString = days[day]["duration"];
                                pharmacyMap.push({
                                    'dayString': dayString,
                                    'durationString': durationString
                                });
                            } else {
                                if (startDay == days[day - 1]["name"]) {
                                    dayString = startDay;
                                    pharmacyMap.push({
                                        'dayString': dayString,
                                        'durationString': durationString
                                    });
                                } else {
                                    dayString = startDay + "-" + days[day - 1]["name"];
                                    pharmacyMap.push({
                                        'dayString': dayString,
                                        'durationString': durationString
                                    });
                                }

                            }
                            startDay = days[day]["name"];
                        } else {
                            if (day == weekdayLength - 1) {
                                dayString = startDay + "-" + days[day]["name"];
                                pharmacyMap.push({
                                    'dayString': dayString,
                                    'durationString': durationString
                                });
                            }
                        }
                        durationString = currentDuration;
                        prevDay = days[day]["name"];
                    }
                    var dayString = days[days.length - 2]["name"];
                    durationString = days[days.length - 2]["duration"];
                    pharmacyMap.push({
                        'dayString': dayString,
                        'durationString': durationString
                    });
                    //add sunday
                    dayString = days[days.length - 1]["name"];
                    durationString = days[days.length - 1]["duration"];
                    pharmacyMap.push({
                        'dayString': dayString,
                        'durationString': durationString
                    });

                    return pharmacyMap;
                }

                function checkStoreCloseOpen(store,pharOrStore) {
                    ////console.log("$scope.SLC.getStoreStatus", $scope.SLC.getStoreStatus)
                    store.isStoreClosed = false;
                    store.isStoreOpen = false;
                    var storeStatusOpen = true;
                    if (store.content.properties.Hr24_Flag.__text.toUpperCase() === 'Y' && pharOrStore === '') {
                        store.isStoreOpen = true;
                        storeStatusOpen = true;
                    }
                    // else if (store.content.properties.Rx24_Flag.__text.toUpperCase() === 'Y' && pharOrStore === 'PH'){
                    //     store.isStoreOpen = true;
                    //     storeStatusOpen = true;
                    // }
                    else {
                        //current time in time zone

                        var currentDateString = storeTimeZoneConversion1(store.content.properties.Timezone.__text);
                        var currentDate = new Date(currentDateString);
                        if (!currentDate || currentDate == 'Invalid Date') {
                            currentDate = new Date();
                        }
                        var currentTime = formatAMPM(currentDate);
                        var currentDay = cvsUtility.getDay(currentDate.getDay());
                        switch (currentDay) {
                            case "Sunday":
                                storeStatusOpen = storeClosingStatus(store, "2", currentDate, currentTime, currentDate,pharOrStore);
                                break;
                            case "Saturday":
                                storeStatusOpen = storeClosingStatus(store, "1", currentDate, currentTime, currentDate,pharOrStore);
                                break;
                            default:
                                storeStatusOpen = storeClosingStatus(store, "0", currentDate, currentTime, currentDate,pharOrStore);
                                break;
                        }
                    }
                    return storeStatusOpen;
                    ////console.log(store)
                }

                function storeTimeZoneConversion1(timeZone) {
                    var offset;
                    var currentDate;
                    if($rootScope.serverTimeStamp != undefined && $rootScope.serverTimeStamp != ""){
                        if($rootScope.serverTimeStamp && typeof $rootScope.serverTimeStamp === "object"){
                            currentDate = new Date($rootScope.serverTimeStamp.__text.split('-').join('/') + " GMT-0700")
                        }else {
                            currentDate = new Date($rootScope.serverTimeStamp.split('-').join('/') + " GMT-0700")
                        }
                    } else{
                        currentDate = new Date();
                    }
                    /*var newUTCDate=currentDate.toUTCString();
                     newUTCDate=newUTCDate.replace("GMT","").trim();
                     var offset=currentDate.getTimezoneOffset();*/
                    switch (timeZone) {
                        case "AST":
                            /*ATLANTIC STANDARD TIME        UTC - 4*/
                            offset = -4;
                            break;
                        case "EST":
                            /*EASTERN STANDARD TIME          UTC - 5*/
                            offset = -5;
                            break;
                        case "EDT":
                            /*EASTERN DAYLIGHT TIME            UTC - 4*/
                            offset = -4;
                            break;
                        case "CST":
                            /*CENTRAL STANDARD TIME          UTC - 6*/
                            offset = -6;
                            break;
                        case "CDT":
                            /*CDT       CENTRAL DAYLIGHT TIME             UTC - 5*/
                            offset = -5;
                            break;
                        case "MST":
                            /*MST      MOUNTAIN STANDARD TIME     UTC - 7*/
                            offset = -7;
                            break;
                        case "MDT":
                            /*MOUNTAIN DAYLIGHT TIME      UTC - 6*/
                            offset = -6;
                            break;
                        case "PST":
                            /*PACIFIC STANDARD TIME            UTC - 8*/
                            offset = -8;
                            break;
                        case "PDT":
                            /*PACIFIC DAYLIGHT TIME               UTC - 7*/
                            offset = -7;
                            break;
                        case "AKST":
                            /*ALASKA TIME    UTC - 9*/
                            offset = -9;
                            break;
                        case "AKDT":
                            /*ALASKA DAYLIGHT TIME               UTC - 8*/
                            offset = -8;
                            break;
                        case "HST":
                            /*HAWAII STANDARD TIME            UTC - 10*/
                            offset = -10;
                            break;
                        case "HADT":
                            /*HAWAII-ALEUTIAN DAYLIGHT TIME        UTC - 9*/
                            offset = -9;
                            break;
                        case "SST":
                            /*SAMOA STANDARD TIME            UTC - 11*/
                            offset = -11;
                            break;
                        case "SDT":
                            /*AMOA DAYLIGHT TIME UTC - 10*/
                            offset = -10;
                            break;
                        case "CHST":
                            /*CHAMORRO STANDARD TIME   UTC +10*/
                            offset = +10;
                            break;
                    }
                    var correctDate = new Date(currentDate.getTime() + offset * 3600 * 1000).toUTCString().replace(/ GMT$/, "");
                    return correctDate;
                }

                function storeTimeZoneConversion(timeZone) {
                    var offsetString, currentDate;
                    if($rootScope.serverTimeStamp != undefined && $rootScope.serverTimeStamp != ""){
                        if($rootScope.serverTimeStamp && typeof $rootScope.serverTimeStamp === "object"){
                            currentDate = new Date($rootScope.serverTimeStamp.__text + " GMT-0700")
                        }else {
                            currentDate = new Date($rootScope.serverTimeStamp + " GMT-0700")
                        }
                    } else{
                        currentDate = new Date();
                    }
                    var newUTCDate = currentDate.toUTCString();
                    newUTCDate = newUTCDate.replace("GMT", "").trim();
                    var offset = currentDate.getTimezoneOffset();
                    switch (timeZone) {
                        case "CST":
                            offsetString = ((Math.abs(offset) - 360) / 60).toFixed(2);
                            offsetString = offsetString.toString().replace('.', '');
                            newUTCDate = newUTCDate + "+" + offsetString;
                            break;
                        case "MST":
                            offsetString = ((Math.abs(offset) - 420) / 60).toFixed(2);
                            offsetString = offsetString.toString().replace('.', '');
                            newUTCDate = newUTCDate + "+" + offsetString;
                            break;
                        case "EST":
                            offsetString = ((Math.abs(offset) - 300) / 60).toFixed(2);
                            offsetString = offsetString.toString().replace('.', '');
                            newUTCDate = newUTCDate + "+" + offsetString;
                            break;
                        case "PST":
                            offsetString = ((Math.abs(offset) - 480) / 60).toFixed(2);
                            offsetString = offsetString.toString().replace('.', '');
                            newUTCDate = newUTCDate + "+" + offsetString;
                            break;
                        default:
                            offsetString = ((Math.abs(offset) - 360) / 60).toFixed(2);
                            offsetString = offsetString.toString().replace('.', '');
                            newUTCDate = newUTCDate + "+" + offsetString;
                            break;
                    }
                    return newUTCDate;
                }

                function getTime(store, currentDay) {
                    return $scope.SLC.getDefaultStoreTiming(currentDay, store);
                }

                function storeClosingStatus(store, index, currentDate, currentTime, currentDay,pharOrStore) {
                    var timings;

                    if(pharOrStore === 'PH'){
                        timings = $scope.SLC.getDefaultStoreTiming(currentDay.getDay(), store);
                    } else {
                        timings = $scope.SLC.getDefaultStoreHrs(currentDay.getDay(), store);
                    }

                    //timings = getTime(store, currentDay);
                    var isStoreOpen = true;
                    if (timings.toUpperCase() == "CLOSED") {
                        store.isStoreOpen = false;
                        store.isStoreClosed = true;
                        isStoreOpen = false
                    } else if(timings.toUpperCase() == "Open 24 Hours".toUpperCase()){
                        store.isStoreOpen = true;
                        store.isStoreClosed = false;
                        isStoreOpen = true
                    } else {
                        var timingsArray = timings.toUpperCase().split('-');
                        var timeString1 = (currentDate.getMonth()+1) + "/" + currentDate.getDate() + "/" + currentDate.getFullYear() + " " + timingsArray[0];
                        var timeString2 = (currentDate.getMonth()+1) + "/" + currentDate.getDate() + "/" + currentDate.getFullYear() + " " + timingsArray[1];
                        var currentTimeString = (currentDate.getMonth()+1) + "/" + currentDate.getDate() + "/" + currentDate.getFullYear() + " " + currentTime.toUpperCase();

                        var timeString1 = moment(timeString1, 'MM/DD/YYYY hh:mm a');
                        var timeString2 = moment(timeString2, 'MM/DD/YYYY hh:mm a');
                        var currentTimeString = moment(currentTimeString, 'MM/DD/YYYY hh:mm a');

                        //Fix 2
                        if(moment(timeString2).isSame(moment().startOf('day'))){
                            timeString2 = moment().endOf('day');
                        }

                        //Fix 3
                        // if (timeString1.isBefore(currentTimeString) && currentTimeString.isBefore(timeString2)) {
                        //     store.isStoreOpen = true;
                        //     isStoreOpen = true
                        // } else if(currentTimeString.isAfter(timeString2)) {
                        //     store.isStoreClosed = false;
                        //     store.isStoreOpen = true;
                        //     isStoreOpen = true;
                        // }else {
                        //     store.isStoreClosed = true;
                        //     store.isStoreOpen = false;
                        //     isStoreOpen = false;
                        // }

                        if (timeString1.isBefore(currentTimeString) && currentTimeString.isBefore(timeString2)) {
                            store.isStoreOpen = true;
                            isStoreOpen = true
                        } else {
                            store.isStoreClosed = true;
                            store.isStoreOpen = false;
                            isStoreOpen = false;
                        }
                    }
                    return isStoreOpen;
                }

                function formatAMPM(date) {
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = (hours < 10 ? "0" + hours : hours) + ':' + minutes + ' ' + ampm;
                    return strTime;
                }

                $scope.SLC.init();
                setInterval(
                    function(){
                        $('a[x-apple-data-detectors="true"]').removeAttr('href');
                    }, 5000
                )
            }]
        }

    }])
})();